// src/pages/Home.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import FormComponent from '../components/Form/FormComponent';

const Home = () => {
  const canonicalUrl = 'https://google.utmsmartmanager.com/';

  // Keep this aligned with public/index.html so you don't emit competing descriptions.
  // (react-snap will include both the static and helmet tags in build/index.html.)
  const metaDescription =
    'Create clean, consistent Google campaign links fast. Built for teams still using legacy (Universal Analytics) UTMs.';

  const ogTitle = 'Free Google UTM Builder | UTM Smart Manager';
  const ogDescription =
    'Create clean, consistent Google campaign links fast. Built for teams still using legacy (Universal Analytics) UTMs.';

  return (
    <div>
      <Helmet>
        <title>Free Google UTM Builder | UTM Smart Manager</title>

        {/* ✅ Canonical: prevents duplicate indexing across variants */}
        <link rel="canonical" href={canonicalUrl} />

        {/* ✅ Primary meta description (aligned with public/index.html) */}
        <meta name="description" content={metaDescription} />

        {/* ✅ Indexing directives (safe defaults) */}
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />

        {/* ✅ Open Graph (sharing + consistency) */}
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />

        {/* ✅ Twitter (optional but harmless) */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={ogDescription} />

        {/* Additional tags as required */}
      </Helmet>

      <FormComponent />
    </div>
  );
};

export default Home;